import{__exports as s}from"../../../../../../_virtual/isAddress.js";Object.defineProperty(s,"__esModule",{value:!0}),s.isAddress=void 0;const e=/^0x[a-fA-F0-9]{40}$/;s.isAddress=function(s){return e.test(s)};export{s as default};
